/**
 * Calculate date range based on period selection
 * @param {string} period - Period value (e.g., 'this_month', 'last_month', etc.)
 * @returns {Object} Object with startDate and endDate in ISO format (YYYY-MM-DD)
 */
export const calculateDateRangeFromPeriod = (period) => {
    if (!period || period === 'all' || period === 'custom') {
        return { startDate: '', endDate: '' };
    }

    const today = new Date();
    let startDate = '';
    let endDate = '';

    switch (period) {
        case 'this_month':
            startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
            break;
        case 'last_month':
            startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear(), today.getMonth(), 0).toISOString().split('T')[0];
            break;
        case 'this_quarter':
            const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
            startDate = new Date(today.getFullYear(), quarterStartMonth, 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear(), quarterStartMonth + 3, 0).toISOString().split('T')[0];
            break;
        case 'last_quarter':
            const lastQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3 - 3;
            startDate = new Date(today.getFullYear(), lastQuarterStartMonth, 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear(), lastQuarterStartMonth + 3, 0).toISOString().split('T')[0];
            break;
        case 'this_year':
            startDate = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear(), 11, 31).toISOString().split('T')[0];
            break;
        case 'last_year':
            startDate = new Date(today.getFullYear() - 1, 0, 1).toISOString().split('T')[0];
            endDate = new Date(today.getFullYear() - 1, 11, 31).toISOString().split('T')[0];
            break;
        default:
            return { startDate: '', endDate: '' };
    }

    return { startDate, endDate };
};

/**
 * Create a filter change handler with automatic date range calculation
 * @param {Function} setFilterFunction - State setter function for filters
 * @returns {Function} Filter change handler function
 */
export const createFilterHandler = (setFilterFunction) => {
    return (field, value) => {
        setFilterFunction(prev => {
            const newFilters = { ...prev, [field]: value };
            
            // Auto-set date range based on period selection
            if (field === 'period' && value) {
                const { startDate, endDate } = calculateDateRangeFromPeriod(value);
                
                if (startDate && endDate) {
                    newFilters.startDate = startDate;
                    newFilters.endDate = endDate;
                } else if (value === 'all') {
                    newFilters.startDate = '';
                    newFilters.endDate = '';
                }
            }
            
            return newFilters;
        });
    };
};

